import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { MODELS } from '../lib/anthropic'

const today = () => new Date().toISOString().slice(0, 10)

export const useAIStore = create(
  persist(
    (set, get) => ({
      isEnabled:  true,
      model:      'SONNET', // key into MODELS — SONNET | OPUS
      dailyCount: 0,
      dailyDate:  today(),

      setEnabled: (v) => set({ isEnabled: v }),
      setModel:   (m) => set({ model: m }),

      // Call before every AI generation — resets counter at midnight, throws if disabled
      assertEnabled() {
        const s = get()
        if (s.dailyDate !== today()) set({ dailyCount: 0, dailyDate: today() })
        if (!s.isEnabled) throw new Error('AI is currently disabled. Enable it in the sidebar AI controls.')
      },

      // Call after every successful generation
      increment() {
        const s = get()
        if (s.dailyDate !== today()) {
          set({ dailyCount: 1, dailyDate: today() })
        } else {
          set({ dailyCount: s.dailyCount + 1 })
        }
      },

      // Returns the Anthropic model string for the current selection
      getModel() {
        return MODELS[get().model] || MODELS.SONNET
      },

      // Current daily count (resets if date changed)
      currentDailyCount() {
        const s = get()
        return s.dailyDate === today() ? s.dailyCount : 0
      },
    }),
    { name: 'acdyon-ai-controls' }
  )
)
